export default __webpack_public_path__ + "static/media/sass.6d76b44e.png";